import classes from './unconstraintForecasteEdit.module.scss';
import { TabPanel, TabView } from 'primereact/tabview';
import NDCHeader from '../NDCHeader';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import { observer } from 'mobx-react';
import UnconstrainedForecastLoadingSkeleton from '../UnconstraintForecastView/components/UnconstrainedForecastViewSkeleton';
import { useUnconstraiedForecastEdit } from './useUnconstrainedForecastEdit';
import SummaryModal from '../SummaryModal';
import { ProgressSpinner } from 'primereact/progressspinner';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import { unconstrainedForecastAllowedRoles } from 'data/fdp/fdpUserRolesValidations';
import ConceptDetailsSkeleton from 'screens/FDP/components/ConceptDetailsSkeleton';
import ConceptDetailsSection from 'screens/FDP/components/ConceptDetails';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import NotesSection from 'screens/FDPScreen/components/NotesSection';
import CopyIcon from 'assets/icons/copyIcon.svg';
import ResetIcon from 'assets/icons/revertIcon.svg';
import { Accordion, AccordionTab } from 'primereact/accordion';

const formatBaseline = (value: string) => {
  const numericValue = Number(value);
  return value !== '-' && !isNaN(numericValue)
    ? numericValue.toLocaleString('en-US')
    : value;
};

const UnconstraintForecastEdit = () => {
  const {
    userModulesRoles,
    isConceptLoading,
    isWholeSalerDateLoading,
    isInvoiceSalesLoading,
    conceptDetails,
    directcurrentNDCIndex,
    indirectcurrentNDCIndex,
    directNDCheading,
    indirectNDCheading,
    forecastingMonthsEdit,
    isUnconstrainedForecastNotesDataLoading,
    unconstrainedForecastEdit,
    showSummary,
    savingAll,
    savingSingle,
    savingForCategory,
    finishmodal,
    modalVisibe,
    contractDetails,
    isDirectMode,
    // lastNDCInput,
    finishModalForCategory,
    copyRowInfo,
    isNoteEdited,
    isNoteDeleted,
    setFinishModalForCategory,
    handleDirectCurrentTabIndex,
    handleIndirectNDCTabChange,
    getInvoiceSalesDetails,
    setShowSummary,
    setModalVisible,
    setFinishModal,
    saveAllNDCForecast,
    saveSingleNDCForecast,
    setIsDirectMode,
    handleCancel,
    isUnconstrainedNoteSaving,
    UnconstrainedForecastNotesData,
    handleNoteAdd,
    updateForecastAdjustment,
    getValueForNdc,
    isValueTypeRadioButtonChecked,
    changeNdcValueType,
    getNdcData,
    checkIfPercentageEnabled,
    togglePercentageUsing,
    getAdjForecast,
    saveCategoryForecast,
    handleCopyValues,
    handleResetValues,
    isToggleVisible,
    handleDeleteNote,
    handleEditNote,
    setNoteData,
    removeNoteData,
    directInputFocus,
    indirectInputFocus,
    directFocused,
    indirectFocused,
    handleDirectKeyPress,
    handleIndirectKeyPress,
    handleDirectFocus,
    handleIndirectFocus,
    handleDirectBlur,
    handleIndirectBlur,
    getBaseLineValue,
  } = useUnconstraiedForecastEdit();

  return (
    <div className={classes.viewContainer}>
      <div className={classes.conceptContainer}>
        <div className={classes.heading}>
          <h2>Unconstrained Forecast</h2>
        </div>
        <div className={classes.conceptInfo}>
          <div style={{ width: '100%' }}>
            {isConceptLoading ? (
              <ConceptDetailsSkeleton />
            ) : (
              <ConceptDetailsSection
                conceptDetails={conceptDetails}
                contractDetails={contractDetails}
                mode="edit"
                path="/unconstraint_forecast/edit"
              />
            )}
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: '1rem', padding: '.5rem' }}>
        <div
          style={{
            display: 'flex',
            flexGrow: 1,
            background: 'var(--bg-card)',
            color: "var(--text-primary)",
            width: '0rem',
          }}
        >
          {isConceptLoading || isWholeSalerDateLoading ? (
            <UnconstrainedForecastLoadingSkeleton />
          ) : unconstrainedForecastEdit.length > 0 ? (
            <div
              style={{
                width: '100%',
                border: '1px solid #E5E7EB',
                paddingTop: '1rem',
                paddingBottom: '1rem',
                borderRadius: '8px',
              }}
            >
              <div style={{ padding: '1rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {/* Direct section start */}
                  {directNDCheading.length > 0 && (
                    <Accordion
                      className={classes.accordianComponent}
                      activeIndex={0}
                      onClick={() => setIsDirectMode(true)}
                    >
                      <AccordionTab header="Direct" className={classes.accordianTabComponent}>
                        <div className={classes.directtabContainer}>
                          {directNDCheading.length > 0 ? (
                            <>
                              <TabView
                                scrollable
                                style={{ width: '100%' }}
                                tabIndex={directcurrentNDCIndex}
                                onTabChange={handleDirectCurrentTabIndex}
                              >
                                {directNDCheading.map((heading, index) => (
                                  <TabPanel
                                    key={index}
                                    header={
                                      <NDCHeader
                                        heading={heading.ndc}
                                        isSelected={directcurrentNDCIndex === index}
                                        tabIndex={index}
                                      />
                                    }
                                  >
                                    <div className={classes.contentContainer}>
                                      <div className={classes.forecastContainer}>
                                        <h4>
                                          <span>
                                            Plan {forecastingMonthsEdit[0].label} -{' '}
                                            {forecastingMonthsEdit[14].label}{' '}
                                            <span style={{ color: 'green' }}>*</span>
                                          </span>
                                        </h4>
                                        <div className={classes.switcherContainer}>
                                          <span className={classes.btnLable}>Number</span>
                                          <InputSwitch
                                            className={classes.switchbtn}
                                            checked={checkIfPercentageEnabled()}
                                            onChange={togglePercentageUsing}
                                          />
                                          <span className={classes.btnLable}>Percent</span>
                                        </div>

                                        <div className={classes.switcherContainer}>
                                          {isToggleVisible() ? (
                                            <div></div>
                                          ) : (
                                            <div className={classes.switcherContainer}>
                                              <span className={classes.btnLable}>Old Values</span>
                                              <InputSwitch
                                                className={classes.switchbtn}
                                                checked={isValueTypeRadioButtonChecked('forecast')}
                                                onChange={() =>
                                                  isValueTypeRadioButtonChecked('forecast')
                                                    ? changeNdcValueType('old')
                                                    : changeNdcValueType('forecast')
                                                }
                                              />
                                              <span className={classes.btnLable}>
                                                Forecast Values
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <hr />
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'space-evenly',
                                          gap: '5rem',
                                          padding: '1rem',
                                        }}
                                      >
                                        <div>
                                          <p>
                                            Pack Size:{' '}
                                            <span>
                                              {
                                                (directNDCheading || [])[directcurrentNDCIndex]
                                                  ?.packSize
                                              }
                                            </span>
                                          </p>
                                        </div>
                                        <div className={classes.saleDetails}>
                                          <div>
                                            <div
                                              style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                paddingLeft: '3rem',
                                              }}
                                            >
                                              YTD:{' '}
                                              {!isInvoiceSalesLoading ? (
                                                getInvoiceSalesDetails(
                                                  directNDCheading[directcurrentNDCIndex]?.ndc,
                                                  'ytd'
                                                )
                                              ) : (
                                                <ProgressSpinner
                                                  style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    padding: 0,
                                                    margin: 0,
                                                  }}
                                                  strokeWidth="8"
                                                  fill="var(--surface-ground)"
                                                  animationDuration="1s"
                                                />
                                              )}
                                            </div>
                                            <div className={classes.vertical}></div>
                                            <div
                                              style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                              }}
                                            >
                                              3MA:{' '}
                                              {!isInvoiceSalesLoading ? (
                                                getInvoiceSalesDetails(
                                                  directNDCheading[directcurrentNDCIndex]?.ndc,
                                                  '3ma'
                                                )
                                              ) : (
                                                <ProgressSpinner
                                                  style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    padding: 0,
                                                    margin: 0,
                                                  }}
                                                  strokeWidth="8"
                                                  fill="var(--surface-ground)"
                                                  animationDuration="1s"
                                                />
                                              )}
                                            </div>
                                            <div className={classes.vertical}></div>
                                            <div
                                              style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                paddingRight: '3rem',
                                              }}
                                            >
                                              PM:{' '}
                                              {!isInvoiceSalesLoading ? (
                                                getInvoiceSalesDetails(
                                                  directNDCheading[directcurrentNDCIndex]?.ndc,
                                                  'pm'
                                                )
                                              ) : (
                                                <ProgressSpinner
                                                  style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    padding: 0,
                                                    margin: 0,
                                                  }}
                                                  strokeWidth="8"
                                                  fill="var(--surface-ground)"
                                                  animationDuration="1s"
                                                />
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className={classes.forecastTable}>
                                        <table>
                                          <thead>
                                            <th>
                                              <td style={{ fontSize: '15px' }}>Forecast Period</td>
                                            </th>
                                            <th>
                                              <td style={{ fontSize: '15px' }}>Strat Code</td>
                                            </th>
                                            <th>
                                              <td style={{ fontSize: '15px' }}>Baseline</td>
                                            </th>
                                            <th>
                                              <td style={{ fontSize: '15px' }}>Adj Forecast</td>
                                            </th>
                                            <th style={{ width: '0.5rem' }}>
                                              <td></td>
                                            </th>
                                          </thead>
                                          <tbody>
                                            {getNdcData().forecast_data.map((data, idx) => {
                                              const isDeramped = data.is_deramped === true;
                                              const derampTitle = isDeramped
                                                ? `NC De-ramp applied — contract term date: ${getNdcData().ContractEndDate ?? ''}`
                                                : undefined;
                                              if (idx < 15) {
                                                return (
                                                  <tr
                                                    key={idx}
                                                    style={{
                                                      backgroundColor: `${
                                                        directFocused === idx ? '#f7f3fe' : ''
                                                      }`,
                                                    }}
                                                  >
                                                    <td
                                                      style={{
                                                        width: '10rem',
                                                      }}
                                                    >
                                                      {forecastingMonthsEdit[idx].label}
                                                    </td>
                                                    <td
                                                      style={{
                                                        color: '#0629D9',
                                                        fontWeight: '600',
                                                        width: '15rem',
                                                      }}
                                                    >
                                                      {getBaseLineValue(idx)}
                                                    </td>
                                                    <td
                                                      style={{
                                                        width: '15rem',
                                                      }}
                                                    >
                                                      {formatBaseline(data.Baseline)}
                                                    </td>
                                                    <td
                                                      style={{
                                                        width: '10rem',
                                                      }}
                                                    >
                                                      {checkIfPercentageEnabled() ? (
                                                        <>
                                                          <input
                                                            style={{
                                                              width: '15rem',
                                                              height: '2rem',
                                                              border: '1px solid #bababa',
                                                              fontSize: '0.9rem',
                                                              padding: '0.3rem 0',
                                                              paddingLeft: '0.5rem',
                                                              borderRadius: '0.3rem',
                                                              margin: 0,
                                                            }}
                                                            title={derampTitle}
                                                            type="text"
                                                            pattern="[+\\-]?(?:0|[1-9]\\d*)(?:\\.\\d+)?"
                                                            value={getValueForNdc(idx)}
                                                            onChange={e =>
                                                              updateForecastAdjustment(
                                                                e.target.value,
                                                                idx
                                                              )
                                                            }
                                                            ref={(el: HTMLInputElement) =>
                                                              (directInputFocus.current[idx] = el)
                                                            }
                                                            onBlur={handleDirectBlur}
                                                            onFocus={() => {
                                                              handleDirectFocus(idx);
                                                            }}
                                                            onKeyDown={e =>
                                                              handleDirectKeyPress(e, idx)
                                                            }
                                                          />
                                                          {/* <ForecastInput
                                                              key={getValueForNdc(
                                                                idx
                                                              )}
                                                              forecastValue={getValueForNdc(
                                                                idx
                                                              )}
                                                              forecastMonthIndex={
                                                                idx
                                                              }
                                                              updateMethod={
                                                                updateForecastAdjustment
                                                              }
                                                              isPercentage={
                                                                true
                                                              }
                                                              ref={(
                                                                el: HTMLInputElement
                                                              ) =>
                                                                (directInputFocus.current[
                                                                  idx
                                                                ] = el)
                                                              }
                                                              onKeyDown={(e) =>
                                                                handleDirectKeyPress(
                                                                  e,
                                                                  idx
                                                                )
                                                              }
                                                              onFocus={() => {
                                                                handleDirectFocus(
                                                                  idx
                                                                );
                                                              }}
                                                              onFocusRemoved={() => {
                                                                handleDirectBlur();
                                                              }}
                                                            /> */}
                                                          <span
                                                            style={{
                                                              fontWeight: '600',
                                                            }}
                                                          >
                                                            {' '}
                                                            %
                                                          </span>
                                                        </>
                                                      ) : (
                                                        <input
                                                          style={{
                                                            width: '15rem',
                                                            height: '2rem',
                                                            border: '1px solid #bababa',
                                                            fontSize: '0.9rem',
                                                            padding: '0.3rem 0',
                                                            paddingLeft: '0.5rem',
                                                            borderRadius: '0.3rem',
                                                            margin: 0,
                                                          }}
                                                          title={derampTitle}
                                                          type="text"
                                                          pattern="[+\\-]?(?:0|[1-9]\\d*)(?:\\.\\d+)?"
                                                          value={getValueForNdc(idx)}
                                                          onChange={e =>
                                                            updateForecastAdjustment(
                                                              e.target.value,
                                                              idx
                                                            )
                                                          }
                                                          ref={(el: HTMLInputElement) =>
                                                            (directInputFocus.current[idx] = el)
                                                          }
                                                          onBlur={handleDirectBlur}
                                                          onFocus={() => {
                                                            handleDirectFocus(idx);
                                                          }}
                                                          onKeyDown={e =>
                                                            handleDirectKeyPress(e, idx)
                                                          }
                                                        />
                                                        // <ForecastInput
                                                        //   isPercentage={false}
                                                        //   key={getValueForNdc(
                                                        //     idx
                                                        //   )}
                                                        //   forecastValue={getValueForNdc(
                                                        //     idx
                                                        //   )}
                                                        //   forecastMonthIndex={
                                                        //     idx
                                                        //   }
                                                        //   updateMethod={
                                                        //     updateForecastAdjustment
                                                        //   }
                                                        //   ref={(
                                                        //     el: HTMLInputElement
                                                        //   ) =>
                                                        //     (directInputFocus.current[
                                                        //       idx
                                                        //     ] = el)
                                                        //   }
                                                        //   onKeyDown={(e) =>
                                                        //     handleDirectKeyPress(
                                                        //       e,
                                                        //       idx
                                                        //     )
                                                        //   }
                                                        //   onFocus={() => {
                                                        //     handleDirectFocus(
                                                        //       idx
                                                        //     );
                                                        //   }}
                                                        //   onFocusRemoved={() => {
                                                        //     handleDirectBlur();
                                                        //   }}
                                                        // />
                                                      )}
                                                    </td>
                                                    <td>
                                                      <div
                                                        style={{
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          gap: '0.5rem',
                                                        }}
                                                      >
                                                        <Button
                                                          style={{
                                                            height: '28px',
                                                            width: '28px',
                                                          }}
                                                          icon={
                                                            <img
                                                              src={CopyIcon}
                                                              style={{
                                                                height: '20px',
                                                                width: '20px',
                                                                cursor: 'pointer',
                                                                opacity:
                                                                  getValueForNdc(idx) !== '-'
                                                                    ? '0.8'
                                                                    : '0.4',
                                                              }}
                                                            />
                                                          }
                                                          disabled={
                                                            getValueForNdc(idx) == '-'
                                                              ? true
                                                              : false
                                                          }
                                                          onClick={() => handleCopyValues(idx)}
                                                          rounded
                                                          text
                                                          aria-label="Filter"
                                                        />

                                                        {copyRowInfo.has(
                                                          directNDCheading[directcurrentNDCIndex]
                                                            .ndc + idx
                                                        ) ? (
                                                          <Button
                                                            style={{
                                                              height: '28px',
                                                              width: '28px',
                                                            }}
                                                            icon={
                                                              <img
                                                                src={ResetIcon}
                                                                style={{
                                                                  height: '20px',
                                                                  width: '20px',
                                                                  cursor: 'pointer',
                                                                  opacity:
                                                                    getValueForNdc(idx) !== '-'
                                                                      ? '0.8'
                                                                      : '0.4',
                                                                }}
                                                              />
                                                            }
                                                            disabled={
                                                              getValueForNdc(idx) == '-'
                                                                ? true
                                                                : false
                                                            }
                                                            onClick={() => handleResetValues(idx)}
                                                            rounded
                                                            text
                                                            aria-label="Filter"
                                                          />
                                                        ) : (
                                                          <div></div>
                                                        )}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                );
                                              }
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </TabPanel>
                                ))}
                              </TabView>
                            </>
                          ) : (
                            <div
                              style={{
                                height: '51rem',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '2rem',
                              }}
                            >
                              {`No Baseline data available for ${
                                isDirectMode ? 'Direct' : 'Indirect'
                              } selling category.`}
                            </div>
                          )}
                        </div>

                        <div className={classes.categoryButtonGroup}>
                          <Button
                            className={classes.saveBtnStyle}
                            onClick={() => setModalVisible(prev => !prev)}
                            disabled={
                              (unconstrainedForecastEdit.length === 0 &&
                                directNDCheading.length === 0) ||
                              !checkIfFunctionalityEnabled(
                                unconstrainedForecastAllowedRoles.bulkUpdateUnconstrainedForecast,
                                userModulesRoles.fdp,
                                userModulesRoles
                              ) ||
                              directNDCheading.length === 0
                            }
                            tooltip={`Will save Unocnstrained forecast for ${directNDCheading[directcurrentNDCIndex]?.ndc}`}
                            tooltipOptions={{ position: 'top' }}
                          >
                            Save
                          </Button>
                          <Button
                            className={classes.finishBtnStyle}
                            tooltip={`Will save Unconstrained Forecast for ${
                              isDirectMode ? 'Direct' : 'Indirect'
                            } NDCs`}
                            tooltipOptions={{ position: 'top' }}
                            onClick={() => setFinishModalForCategory(prev => !prev)}
                            disabled={
                              (unconstrainedForecastEdit.length === 0 &&
                                directNDCheading.length === 0) ||
                              !checkIfFunctionalityEnabled(
                                unconstrainedForecastAllowedRoles.bulkUpdateUnconstrainedForecast,
                                userModulesRoles.fdp,
                                userModulesRoles
                              ) ||
                              directNDCheading.length === 0
                            }
                          >
                            Finish
                          </Button>
                        </div>
                      </AccordionTab>
                    </Accordion>
                  )}
                  {/* Direct section end */}

                  {/* indirect section start */}
                  {indirectNDCheading.length > 0 && (
                    <Accordion
                      className={classes.accordianComponent}
                      onClick={() => setIsDirectMode(false)}
                      activeIndex={directNDCheading.length === 0 ? 0 : -1}
                    >
                      <AccordionTab header="Indirect" className={classes.accordianTabComponent}>
                        <div className={classes.directtabContainer}>
                          {indirectNDCheading.length > 0 && (
                            <>
                              <TabView
                                scrollable
                                style={{ width: '100%' }}
                                tabIndex={indirectcurrentNDCIndex}
                                onTabChange={handleIndirectNDCTabChange}
                              >
                                {indirectNDCheading.map((heading, index) => (
                                  <TabPanel
                                    key={index}
                                    header={
                                      <NDCHeader
                                        heading={heading.ndc}
                                        isSelected={indirectcurrentNDCIndex === index}
                                        tabIndex={index}
                                      />
                                    }
                                  >
                                    <div className={classes.contentContainer}>
                                      <div className={classes.forecastContainer}>
                                        <h4>
                                          <span>
                                            Plan {forecastingMonthsEdit[0].label} -{' '}
                                            {forecastingMonthsEdit[14].label}{' '}
                                            <span style={{ color: 'green' }}>*</span>
                                          </span>
                                        </h4>
                                        <div className={classes.switcherContainer}>
                                          <span className={classes.btnLable}>Number</span>
                                          <InputSwitch
                                            className={classes.switchbtn}
                                            checked={checkIfPercentageEnabled()}
                                            onChange={togglePercentageUsing}
                                          />
                                          <span className={classes.btnLable}>Percent</span>
                                        </div>

                                        <div className={classes.switcherContainer}>
                                          {isToggleVisible() ? (
                                            <div></div>
                                          ) : (
                                            <div className={classes.switcherContainer}>
                                              <span className={classes.btnLable}>Old Values</span>
                                              <InputSwitch
                                                className={classes.switchbtn}
                                                checked={isValueTypeRadioButtonChecked('forecast')}
                                                onChange={() =>
                                                  isValueTypeRadioButtonChecked('forecast')
                                                    ? changeNdcValueType('old')
                                                    : changeNdcValueType('forecast')
                                                }
                                              />
                                              <span className={classes.btnLable}>
                                                Forecast Values
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <hr />
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'space-evenly',
                                          gap: '5rem',
                                          padding: '1rem',
                                        }}
                                      >
                                        <div>
                                          <p>
                                            Pack Size:{' '}
                                            <span>
                                              {
                                                (indirectNDCheading || [])[indirectcurrentNDCIndex]
                                                  ?.packSize
                                              }
                                            </span>
                                          </p>
                                        </div>
                                        <div className={classes.saleDetails}>
                                          <div>
                                            <div
                                              style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                paddingLeft: '3rem',
                                              }}
                                            >
                                              YTD:{' '}
                                              {!isInvoiceSalesLoading ? (
                                                getInvoiceSalesDetails(
                                                  indirectNDCheading[indirectcurrentNDCIndex]?.ndc,
                                                  'ytd'
                                                )
                                              ) : (
                                                <ProgressSpinner
                                                  style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    padding: 0,
                                                    margin: 0,
                                                  }}
                                                  strokeWidth="8"
                                                  fill="var(--surface-ground)"
                                                  animationDuration="1s"
                                                />
                                              )}
                                            </div>
                                            <div className={classes.vertical}></div>
                                            <div
                                              style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                              }}
                                            >
                                              3MA:{' '}
                                              {!isInvoiceSalesLoading ? (
                                                getInvoiceSalesDetails(
                                                  indirectNDCheading[indirectcurrentNDCIndex]?.ndc,
                                                  '3ma'
                                                )
                                              ) : (
                                                <ProgressSpinner
                                                  style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    padding: 0,
                                                    margin: 0,
                                                  }}
                                                  strokeWidth="8"
                                                  fill="var(--surface-ground)"
                                                  animationDuration="1s"
                                                />
                                              )}
                                            </div>
                                            <div className={classes.vertical}></div>
                                            <div
                                              style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                paddingRight: '3rem',
                                              }}
                                            >
                                              PM:{' '}
                                              {!isInvoiceSalesLoading ? (
                                                getInvoiceSalesDetails(
                                                  indirectNDCheading[indirectcurrentNDCIndex]?.ndc,
                                                  'pm'
                                                )
                                              ) : (
                                                <ProgressSpinner
                                                  style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    padding: 0,
                                                    margin: 0,
                                                  }}
                                                  strokeWidth="8"
                                                  fill="var(--surface-ground)"
                                                  animationDuration="1s"
                                                />
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className={classes.forecastTable}>
                                        <table>
                                          <thead>
                                            <th>
                                              <td style={{ fontSize: '15px' }}>Forecast Period</td>
                                            </th>
                                            <th>
                                              <td style={{ fontSize: '15px' }}>Strat Code</td>
                                            </th>
                                            <th>
                                              <td style={{ fontSize: '15px' }}>Baseline</td>
                                            </th>
                                            <th>
                                              <td style={{ fontSize: '15px' }}>Adj Forecast</td>
                                            </th>
                                            <th style={{ width: '0.5rem' }}>
                                              <td></td>
                                            </th>
                                          </thead>
                                          <tbody>
                                            {getNdcData().forecast_data.map((data, idx) => {
                                              if (idx < 15) {
                                                return (
                                                  <tr
                                                    key={idx}
                                                    style={{
                                                      backgroundColor: `${
                                                        indirectFocused === idx ? '#f7f3fe' : ''
                                                      }`,
                                                    }}
                                                  >
                                                    <td
                                                      style={{
                                                        width: '10rem',
                                                      }}
                                                    >
                                                      {forecastingMonthsEdit[idx]?.label}
                                                    </td>
                                                    <td
                                                      style={{
                                                        color: '#0629D9',
                                                        fontWeight: '600',
                                                        width: '15rem',
                                                      }}
                                                    >
                                                      {getBaseLineValue(idx)}
                                                    </td>
                                                    <td
                                                      style={{
                                                        width: '15rem',
                                                      }}
                                                    >
                                                      {formatBaseline(data.Baseline)}
                                                    </td>
                                                    <td
                                                      style={{
                                                        width: '10rem',
                                                      }}
                                                    >
                                                      {checkIfPercentageEnabled() ? (
                                                        <>
                                                          <input
                                                            style={{
                                                              width: '15rem',
                                                              height: '2rem',
                                                              border: '1px solid #bababa',
                                                              fontSize: '0.9rem',
                                                              padding: '0.3rem 0',
                                                              paddingLeft: '0.5rem',
                                                              borderRadius: '0.3rem',
                                                              margin: 0,
                                                            }}
                                                            type="text"
                                                            pattern="[+\\-]?(?:0|[1-9]\\d*)(?:\\.\\d+)?"
                                                            value={getValueForNdc(idx)}
                                                            onChange={e =>
                                                              updateForecastAdjustment(
                                                                e.target.value,
                                                                idx
                                                              )
                                                            }
                                                            ref={(el: HTMLInputElement) =>
                                                              (indirectInputFocus.current[idx] = el)
                                                            }
                                                            onBlur={handleIndirectBlur}
                                                            onFocus={() => handleIndirectFocus(idx)}
                                                            onKeyDown={e =>
                                                              handleIndirectKeyPress(e, idx)
                                                            }
                                                          />
                                                          {/* <ForecastInput
                                                              key={getValueForNdc(
                                                                idx
                                                              )}
                                                              forecastValue={getValueForNdc(
                                                                idx
                                                              )}
                                                              forecastMonthIndex={
                                                                idx
                                                              }
                                                              updateMethod={
                                                                updateForecastAdjustment
                                                              }
                                                              isPercentage={
                                                                true
                                                              }
                                                              ref={(
                                                                el: HTMLInputElement
                                                              ) =>
                                                                (indirectInputFocus.current[
                                                                  idx
                                                                ] = el)
                                                              }
                                                              onKeyDown={(e) =>
                                                                handleIndirectKeyPress(
                                                                  e,
                                                                  idx
                                                                )
                                                              }
                                                              onFocus={() => {
                                                                handleIndirectFocus(
                                                                  idx
                                                                );
                                                              }}
                                                              onFocusRemoved={() => {
                                                                handleIndirectBlur();
                                                              }}
                                                            /> */}
                                                          <span
                                                            style={{
                                                              fontWeight: '600',
                                                            }}
                                                          >
                                                            {' '}
                                                            %
                                                          </span>
                                                        </>
                                                      ) : (
                                                        <input
                                                          style={{
                                                            width: '15rem',
                                                            height: '2rem',
                                                            border: '1px solid #bababa',
                                                            fontSize: '0.9rem',
                                                            padding: '0.3rem 0',
                                                            paddingLeft: '0.5rem',
                                                            borderRadius: '0.3rem',
                                                            margin: 0,
                                                          }}
                                                          type="text"
                                                          pattern="[+\\-]?(?:0|[1-9]\\d*)(?:\\.\\d+)?"
                                                          value={getValueForNdc(idx)}
                                                          onChange={e =>
                                                            updateForecastAdjustment(
                                                              e.target.value,
                                                              idx
                                                            )
                                                          }
                                                          ref={(el: HTMLInputElement) =>
                                                            (indirectInputFocus.current[idx] = el)
                                                          }
                                                          onBlur={handleIndirectBlur}
                                                          onFocus={() => handleIndirectFocus(idx)}
                                                          onKeyDown={e =>
                                                            handleIndirectKeyPress(e, idx)
                                                          }
                                                        />
                                                        // <ForecastInput
                                                        //   isPercentage={false}
                                                        //   key={getValueForNdc(
                                                        //     idx
                                                        //   )}
                                                        //   forecastValue={getValueForNdc(
                                                        //     idx
                                                        //   )}
                                                        //   forecastMonthIndex={
                                                        //     idx
                                                        //   }
                                                        //   updateMethod={
                                                        //     updateForecastAdjustment
                                                        //   }
                                                        //   ref={(
                                                        //     el: HTMLInputElement
                                                        //   ) =>
                                                        //     (indirectInputFocus.current[
                                                        //       idx
                                                        //     ] = el)
                                                        //   }
                                                        //   onKeyDown={(e) =>
                                                        //     handleIndirectKeyPress(
                                                        //       e,
                                                        //       idx
                                                        //     )
                                                        //   }
                                                        //   onFocus={() => {
                                                        //     handleIndirectFocus(
                                                        //       idx
                                                        //     );
                                                        //   }}
                                                        //   onFocusRemoved={() => {
                                                        //     handleIndirectBlur();
                                                        //   }}
                                                        // />
                                                      )}
                                                    </td>
                                                    <td>
                                                      <div
                                                        style={{
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          gap: '0.5rem',
                                                        }}
                                                      >
                                                        <Button
                                                          style={{
                                                            height: '28px',
                                                            width: '28px',
                                                          }}
                                                          icon={
                                                            <img
                                                              src={CopyIcon}
                                                              style={{
                                                                height: '20px',
                                                                width: '20px',
                                                                cursor: 'pointer',
                                                                opacity:
                                                                  getValueForNdc(idx) !== '-'
                                                                    ? '0.8'
                                                                    : '0.4',
                                                              }}
                                                            />
                                                          }
                                                          disabled={
                                                            getValueForNdc(idx) == '-'
                                                              ? true
                                                              : false
                                                          }
                                                          onClick={() => handleCopyValues(idx)}
                                                          rounded
                                                          text
                                                          aria-label="Filter"
                                                        />

                                                        {copyRowInfo.has(
                                                          indirectNDCheading[
                                                            indirectcurrentNDCIndex
                                                          ].ndc + idx
                                                        ) ? (
                                                          <Button
                                                            style={{
                                                              height: '28px',
                                                              width: '28px',
                                                            }}
                                                            icon={
                                                              <img
                                                                src={ResetIcon}
                                                                style={{
                                                                  height: '20px',
                                                                  width: '20px',
                                                                  cursor: 'pointer',
                                                                  opacity:
                                                                    getValueForNdc(idx) !== '-'
                                                                      ? '0.8'
                                                                      : '0.4',
                                                                }}
                                                              />
                                                            }
                                                            disabled={
                                                              getValueForNdc(idx) == '-'
                                                                ? true
                                                                : false
                                                            }
                                                            onClick={() => handleResetValues(idx)}
                                                            rounded
                                                            text
                                                            aria-label="Filter"
                                                          />
                                                        ) : (
                                                          <div></div>
                                                        )}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                );
                                              }
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </TabPanel>
                                ))}
                              </TabView>
                            </>
                          )}
                        </div>

                        <div className={classes.categoryButtonGroup}>
                          <Button
                            className={classes.saveBtnStyle}
                            onClick={() => setModalVisible(prev => !prev)}
                            disabled={
                              (unconstrainedForecastEdit.length === 0 &&
                                indirectNDCheading.length === 0) ||
                              !checkIfFunctionalityEnabled(
                                unconstrainedForecastAllowedRoles.bulkUpdateUnconstrainedForecast,
                                userModulesRoles.fdp,
                                userModulesRoles
                              ) ||
                              indirectNDCheading.length === 0
                            }
                            tooltip={`Will save Unocnstrained forecast for ${indirectNDCheading[indirectcurrentNDCIndex]?.ndc}`}
                            tooltipOptions={{ position: 'top' }}
                          >
                            Save
                          </Button>
                          <Button
                            className={classes.finishBtnStyle}
                            tooltip={`Will save Unconstrained Forecast for ${
                              isDirectMode ? 'Direct' : 'Indirect'
                            } NDCs`}
                            tooltipOptions={{ position: 'top' }}
                            onClick={() => setFinishModalForCategory(prev => !prev)}
                            disabled={
                              (unconstrainedForecastEdit.length === 0 &&
                                indirectNDCheading.length === 0) ||
                              !checkIfFunctionalityEnabled(
                                unconstrainedForecastAllowedRoles.bulkUpdateUnconstrainedForecast,
                                userModulesRoles.fdp,
                                userModulesRoles
                              ) ||
                              indirectNDCheading.length === 0
                            }
                          >
                            Finish
                          </Button>
                        </div>
                      </AccordionTab>
                    </Accordion>
                  )}
                  {/* indirect section end */}
                </div>

                {(directNDCheading.length > 0 || indirectNDCheading.length > 0) && (
                  <div className={classes.bottomBtngroup}>
                    <Button
                      style={{
                        backgroundColor: '#4D2E6D',
                        color: '#FFFFFF',
                        fontWeight: 600,
                        border: 'none',
                      }}
                      onClick={() => setShowSummary(true)}
                    >
                      Show Summary
                    </Button>
                    <div>
                      <Button
                        style={{
                          backgroundColor: '#D8000C',
                          color: '#FFFFFF',
                          fontWeight: 600,
                          border: 'none',
                        }}
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                      <Button
                        style={{
                          backgroundColor: '#4D2E6D',
                          color: '#FFFFFF',
                          fontWeight: 600,
                          border: 'none',
                        }}
                        onClick={() => setFinishModal(prev => !prev)}
                        disabled={
                          (unconstrainedForecastEdit.length === 0 &&
                            directNDCheading.length === 0 &&
                            indirectNDCheading.length === 0) ||
                          !checkIfFunctionalityEnabled(
                            unconstrainedForecastAllowedRoles.bulkUpdateUnconstrainedForecast,
                            userModulesRoles.fdp,
                            userModulesRoles
                          ) ||
                          (isDirectMode
                            ? directNDCheading.length === 0
                            : indirectNDCheading.length === 0)
                        }
                        tooltip="Will save Unconstrained forecast for all Direct and Indirect NDCs"
                        tooltipOptions={{ position: 'top' }}
                      >
                        Finish All
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div
              style={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2rem',
                width: '100%',
              }}
            >
              No Baseline data available !!
            </div>
          )}
        </div>
        <NotesSection
          mode="edit"
          isNotesDataLoading={
            isUnconstrainedForecastNotesDataLoading || isWholeSalerDateLoading || isConceptLoading
          }
          isNoteAddLoading={isUnconstrainedNoteSaving}
          notesData={UnconstrainedForecastNotesData}
          setNoteData={setNoteData}
          removeNoteData={removeNoteData}
          handleAddNote={handleNoteAdd}
          handleEditNote={handleEditNote}
          editLoading={isNoteEdited}
          handleDeleteNote={handleDeleteNote}
          deleteLoading={isNoteDeleted}
          isAddNewButtonDisabled={
            !checkIfFunctionalityEnabled(
              unconstrainedForecastAllowedRoles.bulkUpdateUnconstrainedForecast,
              userModulesRoles.fdp,
              userModulesRoles
            ) || (isDirectMode ? directNDCheading.length === 0 : indirectNDCheading.length === 0)
          }
        />
      </div>

      {/* single save modal component */}
      <ConfirmationModal
        visibility={modalVisibe}
        modalHeading=""
        modalContent={`Are you sure want to create the Unconstrained Forecast for NDC -
          ${
            isDirectMode
              ? directNDCheading[directcurrentNDCIndex]?.ndc
              : indirectNDCheading[indirectcurrentNDCIndex]?.ndc
          }
          ?`}
        loading={savingSingle}
        confirmLabel="Create"
        handleCancel={() => setModalVisible(prev => !prev)}
        handleConfirm={() =>
          saveSingleNDCForecast(
            isDirectMode
              ? directNDCheading[directcurrentNDCIndex].ndc
              : indirectNDCheading[indirectcurrentNDCIndex].ndc
          )
        }
      />

      {/* Finish modal component */}
      <ConfirmationModal
        visibility={finishmodal || finishModalForCategory}
        modalHeading="Confirmation"
        modalContent={`Are you sure want to create Unconstrained Forecast for all Pack
          Sizes ${
            finishModalForCategory ? `for ${isDirectMode ? 'Direct' : 'Indirect'} category` : ''
          } in ${conceptDetails?.concept}?`}
        loading={savingAll || savingForCategory}
        confirmLabel="Create"
        handleCancel={() => {
          if (finishmodal) {
            setFinishModal(prev => !prev);
          } else if (finishModalForCategory) {
            setFinishModalForCategory(prev => !prev);
          }
        }}
        handleConfirm={() =>
          finishModalForCategory ? saveCategoryForecast() : saveAllNDCForecast()
        }
      />

      {/* Summary Modal */}
      <SummaryModal
        visibility={showSummary}
        toggleVisibility={() => setShowSummary(prev => !prev)}
        forecastingMonths={forecastingMonthsEdit}
        getAdjForecast={getAdjForecast}
        directNDCheading={directNDCheading}
        indirectNDCheading={indirectNDCheading}
      />
    </div>
  );
};

export default observer(UnconstraintForecastEdit);
